import isPropValid from "@emotion/is-prop-valid";
import styled from "@emotion/styled";
import { Box, type Theme, Typography } from "@mui/material";
import { UnstyledLink } from "Components/_Shared/Routing/UnstyledLink";
import type { FC, HTMLAttributeAnchorTarget } from "react";
import type React from "react";
import { useLocation } from "react-router-dom";

export interface AppBarMenuItemProps {
  readonly name: string;
  readonly to: string;
  readonly icon: React.ReactNode;
  readonly target?: HTMLAttributeAnchorTarget;
}

const StyledWrapper = styled(Box, {
  shouldForwardProp: isPropValid,
})<{ $active: boolean }>`
  padding: ${(props) => props.theme.spacing(2)} ${(props) => props.theme.spacing(4)};

  & p, & svg {
    color: ${(props) => (props.$active ? props.theme.colors.brandPrimary : props.theme.colors.textSecondary)}
  }

  &:hover p, &:hover svg {
    transition: color 250ms;
    color: ${(props) => props.theme.colors.brandPrimary};
  }
`;

export const AppBarMenuItem: FC<AppBarMenuItemProps> = ({ name, to, icon, target }) => {
  const { pathname } = useLocation();
  return (
    <StyledWrapper $active={pathname === to}>
      <UnstyledLink to={to} target={target} rel={target === "_blank" ? "noopener noreferrer" : undefined}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {icon}
          <Typography color="textSecondary" variant="body2" sx={{ marginLeft: 1.5, marginTop: 0.5 }}>
            {name}
          </Typography>
        </Box>
      </UnstyledLink>
    </StyledWrapper>
  );
};
